import React from 'react';
import { FormGroup } from 'react-bootstrap';
import { Control, Controller } from 'react-hook-form';
import styles from './providersStep.module.scss';
import { DataVendor, ItemList, MultiDropdownItem } from 'v2/models';
import MultiSelectDataVendors, {
  initalState,
} from 'v2/form/CustomSelectors/Multiselect/MultiSelectDataVendors';
import {
  CreateSearchFormData,
  ExcludeDataVendorFilterForm,
  excludeDataVendorsFilterValue,
} from '../CreateSearchSchema';

interface ExcludeDataVendorsFilterProps {
  control: Control<CreateSearchFormData>;
}

const ExcludeDataVendorsFilter = ({
  control,
}: ExcludeDataVendorsFilterProps) => {
  return (
    <div className="mt-5">
      <span className={styles.textForm}>Exclude Providers</span>
      <FormGroup className={styles.inputForm}>
        <Controller
          name={'filters.exclude_providers_drm'}
          control={control}
          rules={{
            required: true,
          }}
          render={({
            field: { onChange, value: currentExcludedDataVendors },
          }) => {
            let defaultValue: ItemList | undefined;
            if (currentExcludedDataVendors) {
              const excludedDataVendors =
                currentExcludedDataVendors as ExcludeDataVendorFilterForm;
              defaultValue = {
                ...excludedDataVendors,
                list: excludedDataVendors.list.map((dv) => {
                  return { id: dv.data_vendor_id, name: dv.name };
                }) as MultiDropdownItem[],
              };
            }

            return (
              <MultiSelectDataVendors
                onChange={(value) => {
                  const formData: excludeDataVendorsFilterValue[] = (
                    value?.list as DataVendor[]
                  ).map((dataVendor) => {
                    return {
                      data_vendor_id: dataVendor.id,
                      data_provider_id: dataVendor.data_provider,
                      name: dataVendor.name,
                    };
                  });

                  onChange({
                    ...value,
                    list: formData,
                  });
                }}
                defaultValues={
                  defaultValue ? (defaultValue as ItemList) : initalState
                }
                containFiles={false}
                clearAll={false}
              />
            );
          }}
        />
      </FormGroup>
    </div>
  );
};

export default ExcludeDataVendorsFilter;
